// CSS Browser Selector v0.4.0 (Nov 02, 2010) | Rafael Lima (http://rafael.adm.br) | http://rafael.adm.br/css_browser_selector | License: http://creativecommons.org/licenses/by/2.5/ | Contributors: http://rafael.adm.br/css_browser_selector#contributors
function css_browser_selector(u){var ua=u.toLowerCase(),is=function(t){return ua.indexOf(t)>-1},g='gecko',w='webkit',s='safari',o='opera',m='mobile',h=document.documentElement,b=[(!(/opera|webtv/i.test(ua))&&/msie\s(\d)/.test(ua))?('ie ie'+RegExp.$1):is('firefox/2')?g+' ff2':is('firefox/3.5')?g+' ff3 ff3_5':is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')?g+' ff3':is('gecko/')?g:is('opera')?o+(/version\/(\d+)/.test(ua)?' '+o+RegExp.$1:(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')):is('konqueror')?'konqueror':is('blackberry')?m+' blackberry':is('android')?m+' android':is('chrome')?w+' chrome':is('iron')?w+' iron':is('applewebkit/')?w+' '+s+(/version\/(\d+)/.test(ua)?' '+s+RegExp.$1:''):is('mozilla/')?g:'',is('j2me')?m+' j2me':is('iphone')?m+' iphone':is('ipod')?m+' ipod':is('ipad')?m+' ipad':is('mac')?'mac':is('darwin')?'mac':is('webtv')?'webtv':is('win')?'win'+(is('windows nt 6.0')?' vista':''):is('freebsd')?'freebsd':(is('x11')||is('linux'))?'linux':'','js']; c = b.join(' '); h.className += ' '+c; return c;}; css_browser_selector(navigator.userAgent);

jQuery(function(){
  
  // Superfish dropdown menu
  jQuery('ul.sf-menu').superfish();

  // select current tab on navigation
  jQuery('.sf-menu a').each(function() {
    if (jQuery(this).attr('href')  ===  window.location.pathname) {
      jQuery(this).addClass('current');
    }
  });
  
  
});

jQuery(document).ready(function() {  
  
  
  if (jQuery('.slideshow li').length > 1) {
    
    jQuery("#featured .slideshow").easySlider({
      auto: true, 
      continuous: true,
      speed: 800,
      pause: 9000,
      prevText: '&lsaquo;',
      nextText: '&rsaquo;'
    });
  }

  // Cross browser placeholder text
  jQuery('[placeholder]').focus(function() {
    var input = $(this);
    if (input.val() == input.attr('placeholder')) {
      input.val('');
      input.removeClass('placeholder');
    }
  }).blur(function() {
    var input = $(this);
    if (input.val() == '' || input.val() == input.attr('placeholder')) {
      input.addClass('placeholder');
      input.val(input.attr('placeholder'));
    }
  }).blur();
  jQuery('[placeholder]').parents('form').submit(function() {
    jQuery(this).find('[placeholder]').each(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
        input.val('');
      }
    })
  });
  

  if (jQuery('body').hasClass('template-collection')) {
    jQuery('#main-nav li a[href*="/collection"]').addClass('current');
  };
  
  if (jQuery('body').hasClass('template-collection')) {
    jQuery('#main-nav li a[href*="/collections"]').addClass('current');
  };
  
  if (jQuery('body').hasClass('template-product')) {
    jQuery('#main-nav li a[href*="/collection"]').addClass('current');
  };
  
});
